export default "__VITE_ASSET__3c41fb94__"